
export async function submitReviewFormInit() {
    const {ProductForm} = await import('../../form/productForm');
    new ProductForm(
        '/api/v1/product/submit-review',
        'frm-detailReview',
        'ratingModal',
        'productReview-errors',
        'review-token',
        true,
        true
    );
}

export async function submitRequestFormInit() {
    const {ProductForm} = await import('../../form/productForm');
    new ProductForm(
        '/api/v1/product/submit-request',
        'frm-request',
        'questionModal',
        'productRequest-errors',
        'request-token',
        undefined,
        true,
        true
    );
}